<template>
    <div>主页</div>
</template>

<script>
export default {
    mounted() {}
}
</script>
